import { TeaserType } from './TeaserType.ts';

export enum TeaserTouchPoint {
	ENTRYPAGE = 'entrypage',
	PRODUCTLIST = 'productlist',
	MEINUP = 'meinup',
	MEINKONTO = 'meinkonto',
	BASKET = 'basket',
	DETAILVIEW = 'detailview',
	RETAILER_SELECTION = 'retailer_selection'
}

export function getTeaserTouchPoint(value: string): TeaserTouchPoint | undefined {
	const touchPoint = Object.keys(TeaserTouchPoint).find(key => TeaserTouchPoint[key as keyof typeof TeaserTouchPoint] === value);
	return touchPoint ? TeaserTouchPoint[touchPoint as keyof typeof TeaserTouchPoint] : undefined;
}

export function getShowUpLogo(teaserType: TeaserType, touchPoint: TeaserTouchPoint | undefined) {
	const teaserWithoutLogo = [
		TeaserType.UPGRADE_TEASER,
		TeaserType.PLUS_RENEW_TEASER,
		TeaserType.VIP_UPGRADE_TEASER,
		TeaserType.VIP_RENEW_TEASER
	];
	return !(teaserWithoutLogo.includes(teaserType) && touchPoint === TeaserTouchPoint.DETAILVIEW);
}
